'use client';

import { PROGRAM_TEMPLATE_LEGAL_NOTICE_PREVIEW } from '@court-sync/shared';
import { cn } from '@/lib/utils';

/** Subtle one-line notice on the template preview step only. */
export function ProgramTemplateLegalNotice({ className }: { className?: string }) {
  return (
    <p
      role="note"
      className={cn('text-xs leading-relaxed text-gray-500 dark:text-gray-400', className)}
    >
      {PROGRAM_TEMPLATE_LEGAL_NOTICE_PREVIEW}
    </p>
  );
}
